import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DataService } from 'src/app/service/data.service';
import { TreeItem } from '../controls/tree/tree.component';

@Component({
    selector: 'app-activities',
    templateUrl: './activities.component.html',
    styleUrls: ['./activities.component.css'],
    standalone: false
})
export class ActivitiesComponent implements OnInit {

  title: string;
  menuItems: TreeItem[];
  url: string;

  constructor(public router: Router,
    public dataSrv: DataService, public route: ActivatedRoute) {
    this.menuItems = new Array<TreeItem>(
      new TreeItem("Overview", null, "/activities/overview", null, false),
      new TreeItem("Execution Plans", null, "/activities/executionplans", null, false),
      new TreeItem("Downloads", null, "/activities/downloads", null, false),
      new TreeItem("Notifications", null, "/activities/notifications", null, false)
    );
  }

  ngOnInit(): void {
    this.url = this.router.routerState.snapshot.url;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.url = this.router.routerState.snapshot.url;
      }
    });
  }

}
